import { Typography } from '@mui/material';

import { useAppSelector } from '@/hooks/useAppSelector';

import { selectNarrative } from '@/data/reservation.slice';

const ReservationSummaryNarrative = () => {
  const narrative = useAppSelector(selectNarrative);

  return (
    <Typography
      dangerouslySetInnerHTML={{
        __html: narrative || '',
      }}></Typography>
  );
};

export { ReservationSummaryNarrative };
